import { render, staticRenderFns } from "./QuestionsTypeRatio.vue?vue&type=template&id=9f5a1248&scoped=true&"
import script from "./QuestionsTypeRatio.vue?vue&type=script&lang=js&"
export * from "./QuestionsTypeRatio.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsTypeRatio.vue?vue&type=style&index=0&id=9f5a1248&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5a1248",
  null
  
)

export default component.exports